// API Configuration
// In development, the backend runs on port 3001
// In production, this would be your production API URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://newdietitianweb-615263253386.europe-west3.run.app/api';

const DEFAULT_MEAL_PLAN_SERVICE_URL = 'https://meal-plan-builder-615263253386.europe-west3.run.app';

/** Python meal-plan service (Flask on Cloud Run). Override with:
 *  - REACT_APP_CREATE_MEAL_PLAN_URL — full URL to POST
 *  - REACT_APP_MEAL_PLAN_SERVICE_URL — origin only, /api/create-meal-plan is appended */
export const CREATE_MEAL_PLAN_ENDPOINT =
  process.env.REACT_APP_CREATE_MEAL_PLAN_URL ||
  `${(process.env.REACT_APP_MEAL_PLAN_SERVICE_URL || DEFAULT_MEAL_PLAN_SERVICE_URL).replace(/\/$/, '')}/api/create-meal-plan`;

export default API_BASE_URL;
